import styled from 'styled-components'
import { FormHelperText, Button } from '@material-ui/core'
import {MaterialSelector} from "components/Selector";

export const InputContainer = styled.div`
  margin-bottom: 1.5rem;
  font-size: 16px;
`

export const SingleCheckboxContainer = styled.div`
  padding: 0 1rem;
  font-size: 14px;
`

export const CheckboxLabel = styled.div`
  font-size: 14px;
`

export const SectionContainer = styled.div`
  margin: 1.5rem 0;
  font-size: 16px;
`

export const ButtonsContainer = styled.div`
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  position: sticky;
  bottom: 0;
  padding: 1rem 0;
  background: white;
  z-index: 10;
`

export const CenteredButtonsContainer = styled.div`
  font-size: 16px;
  display: flex;
  flex-direction: column;
  position: sticky;
  bottom: 0;
  padding: 1rem 0;
  background: white;
  z-index: 10;
  align-items: center;
`

export const CalendarSectionContainer = styled.div`
  margin-bottom: 1rem;
  font-size: 16px;
`

export const PopupButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const PopupButton = styled(Button)`
  width: 48% !important;
`

export const StyledSubmitButton = styled(Button)`
  width: 78% !important;
`

export const StyledSecondaryButton = styled(Button)`
  width: 18% !important;
`

export const StyledOverviewEditButton = styled(Button)`
  width: 78% !important;
  color: #ff6a69 !important;
`

export const StyledFormHelperText = styled(FormHelperText)`
  color: #F44336;
  margin: 0 0.875rem;
`

export const PopupContainer = styled.div`
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background: white;
`

export const PopupTitle = styled.div`
  margin-bottom: 1.75rem;
  font-size: 1.2rem;
  line-height: 1.4;
  font-weight: 600;
`

export const PopupDescription = styled.div`
  margin-bottom: 1.75rem;
  line-height: 1.5;
`

export const StyledMaterialSelector = styled(MaterialSelector)`
  padding-right: 2rem !important;
`

export const HelperText = styled.p`
  color: rgba(0, 0, 0, 0.54);
  margin: 0rem 0rem 0.75rem 0rem;
  font-size: 0.75rem;
  text-align: left;
`

export const PriorityShiftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--error-main);
  margin-left: 0.5rem;
`